/*
 * The two providers' own marks, drawn rather than fetched.
 *
 * They are brand assets, not design-system style, so they live here instead of
 * in @wundo/ui — which is also why these are the only colours in the app code
 * that are not tokens: they are Google's and Microsoft's, and a token would be
 * a claim that Wundo gets to choose them.
 */

export function GoogleIcon({ className = 'size-4.5' }: { className?: string }) {
  return (
    <svg viewBox='0 0 24 24' aria-hidden='true' className={className}>
      <path
        fill='#4285F4'
        d='M23.52 12.27c0-.82-.07-1.6-.21-2.36H12v4.47h6.46a5.52 5.52 0 0 1-2.4 3.62v3.01h3.88c2.27-2.09 3.58-5.17 3.58-8.84z'
      />
      <path
        fill='#34A853'
        d='M12 24c3.24 0 5.96-1.08 7.94-2.91l-3.88-3.01c-1.08.72-2.45 1.15-4.06 1.15-3.13 0-5.78-2.11-6.73-4.95H1.26v3.11A11.996 11.996 0 0 0 12 24z'
      />
      <path
        fill='#FBBC05'
        d='M5.27 14.28a7.2 7.2 0 0 1 0-4.56V6.61H1.26a12 12 0 0 0 0 10.78l4.01-3.11z'
      />
      <path
        fill='#EA4335'
        d='M12 4.77c1.77 0 3.35.61 4.6 1.8l3.44-3.44C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.69 1.26 6.61l4.01 3.11C6.22 6.88 8.87 4.77 12 4.77z'
      />
    </svg>
  );
}

export function MicrosoftIcon({ className = 'size-4.5' }: { className?: string }) {
  return (
    <svg viewBox='0 0 24 24' aria-hidden='true' className={className}>
      <path fill='#F25022' d='M1 1h10.4v10.4H1z' />
      <path fill='#7FBA00' d='M12.6 1H23v10.4H12.6z' />
      <path fill='#00A4EF' d='M1 12.6h10.4V23H1z' />
      <path fill='#FFB900' d='M12.6 12.6H23V23H12.6z' />
    </svg>
  );
}
